// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import CartProductDetail from "component/CartProductDetail";
// import "./CartPage.css";
// import CartShowMore from "component/CartShowMore";
// import discount from "assets/Images/discount.png";
// import Service from "services/service";
// import { globalStore } from "stores/globalStore";
// import { Modal, message, Input } from "antd";

// const formatDate = (dateString) => {
//   if (!dateString) return "";
//   const date = new Date(dateString);
//   return `${date.getMonth() + 1}/${date.getDate()}`;
// };

// const CartPage = () => {
//   const {
//     cartPageData,
//     setCartPageData,
//     couponData,
//     setCouponData,
//     setApplyCouponData,
//   } = globalStore();

//   console.log(cartPageData);

//   const [selectedCoupon, setSelectedCoupon] = useState(null);
//   const [selectedCount, setSelectedCount] = useState(0);
//   const [totalCount, setTotalCount] = useState(0);
//   const [quantity, setQuantity] = useState(1);
//   const [selectedTotal, setSelectedTotal] = useState(0);
//   const [mrpAmount, setMrpAmount] = useState(0);
//   const [discountAmount, setDiscountAmount] = useState(0);
//   const [allMrpAmount, setAllMrpAmount] = useState(0);
//   const [allDiscountAmount, setAllDiscountAmount] = useState(0);
//   const [allTotalPrice, setAllTotalPrice] = useState(0);
//   const [isCouponModalVisible, setIsCouponModalVisible] = useState(false);
//   const [couponCode, setCouponCode] = useState("");
//   const navigate = useNavigate();
// const {  setCartCount} = globalStore();
//   const showCouponModal = () => {
//     setIsCouponModalVisible(true);
//   };

//   useEffect(() => {
//     if (cartPageData?.items) {
//       const selectedItems = cartPageData.items.filter(
//         (item) => item.isSelected
//       );

//       const totalSelectedPrice = selectedItems.reduce(
//         (sum, item) =>
//           sum + item.customTShirtPrint.product.discountPrice * item.quantity,
//         0
//       );

//       const totalMrp = selectedItems.reduce(
//         (sum, item) =>
//           sum + item.customTShirtPrint.product.price * item.quantity,
//         0
//       );

//       const totalDiscount = totalMrp - totalSelectedPrice;

//       setSelectedCount(selectedItems.length);
//       setSelectedTotal(totalSelectedPrice);
//       setMrpAmount(totalMrp);
//       setDiscountAmount(totalDiscount);

//       // Calculate all items summary
//       const totalAllMrp = cartPageData.items.reduce(
//         (sum, item) =>
//           sum + item.customTShirtPrint.product.price * item.quantity,
//         0
//       );

//       const totalAllDiscounted = cartPageData.items.reduce(
//         (sum, item) =>
//           sum + item.customTShirtPrint.product.discountPrice * item.quantity,
//         0
//       );

//       setAllMrpAmount(totalAllMrp);
//       setAllDiscountAmount(totalAllMrp - totalAllDiscounted);
//       setAllTotalPrice(totalAllDiscounted);

//       setTotalCount(cartPageData.items.length);
//     }
//   }, [cartPageData]);

//   const getAllCartData = async () => {
//     try {
//       const response = await Service.getAllCartData();
//       const updatedData = {
//         ...response.data.data,
//         items: response.data.data.items.map((item) => ({
//           ...item,
//           isSelected: false,
//         })),
//       };

//       setCartPageData(updatedData);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fetchCouponData = async () => {
//     try {
//       const response = await Service.getCuponDetails();
//       if (response?.data) {
//         setCouponData({
//           couponCodeDetails: response.data.data,
//         });
//       } else {
//         console.error("No data in API response:", response);
//       }
//     } catch (error) {
//       console.error("Error fetching coupon data:", error);
//     }
//   };

//   useEffect(() => {
//     getAllCartData();
//     fetchCouponData();
//   }, []);

//   const removeProduct = async () => {
//     try {
//       const selectedItems = cartPageData.items
//         .filter((item) => item.isSelected)
//         .map((item) => item.customTShirtPrint._id);

//       if (selectedItems.length === 0) {
//         message.warning("No items selected for removal.");
//         return;
//       }

//       const payload = {
//         itemIds: selectedItems,
//       };

//       const response = await Service.removeItemFromCart(payload);
//       if (response?.data.meta?.status) {
//         const updatedItems = cartPageData.items.filter(
//           (item) => !item.isSelected
//         );

//         setCartPageData({
//           ...cartPageData,
//           items: updatedItems,
//         });
//         setQuantity(0);

//         message.success("Selected items removed successfully.");
//       } else {
//         message.error("Failed to remove items.");
//       }
//     } catch (error) {
//       console.error("Error removing items:", error);
//       message.error("An error occurred while removing items.");
//     }
//   };

//   const applyCouponWithCode = async () => {
//     if (!couponCode) {
//       message.warning("Please enter a coupon code!");
//       return;
//     }

//     try {
//       const payload = {
//         cartId: cartPageData._id,
//         couponCode: couponCode.trim(),
//       };

//       const response = await Service.applyCouponWithCode(payload);

//       if (response?.meta?.status) {
//         message.success("Coupon applied successfully!");
//         setApplyCouponData(response.data);

//         // Refresh cart data after applying the coupon
//         await getAllCartData();

//         setIsCouponModalVisible(false);
//       } else {
//         message.error("Invalid coupon or failed to apply.");
//       }
//     } catch (error) {
//       console.error("Error applying coupon:", error);
//       message.error("An error occurred while applying the coupon.");
//     }
//   };

//   const showConfirm = () => {
//     Modal.confirm({
//       title: "Are you sure you want to remove the selected items?",
//       content: "This action cannot be undone.",
//       okText: "Yes, Remove",
//       okType: "danger",
//       cancelText: "Cancel",
//       onOk: removeProduct,
//       onCancel() {
//         message.info("Item removal canceled.");
//       },
//     });
//   };

//   const addToWishlist = async () => {
//     try {
//       const selectedItems = cartPageData.items
//         .filter((item) => item.isSelected)
//         .map((item) => ({
//           product: item.customTShirtPrint.product._id,
//           tShirtSize: item.customTShirtPrint.tShirtSize,
//         }));

//       if (selectedItems.length === 0) {
//         message.warning("No items selected to add to the wishlist.");
//         return;
//       }

//       const payload = {
//         items: selectedItems,
//       };

//       const response = await Service.addOrUpdateWishlistService(payload);
//       if (response?.meta?.status) {
//         message.success("Selected items added to wishlist successfully.");
//         removeProduct();
//       } else {
//         message.error("Failed to add items to wishlist.");
//       }
//     } catch (error) {
//       message.error("An error occurred while adding items to the wishlist.");
//     }
//   };

//   const applyCoupon = async () => {
//     if (!selectedCoupon) {
//       message.warning("Please select a coupon first!");
//       return;
//     }

//     try {
//       const payload = {
//         coupon: selectedCoupon._id,
//         cartId: cartPageData._id,
//       };

//       const response = await Service.applyCouponService(payload);
//       if (response?.meta?.status) {
//         message.success("Coupon applied successfully!");
//         setApplyCouponData(selectedCoupon);

//         // Refresh cart data after applying the coupon
//         await getAllCartData();
//       } else {
//         message.error("Failed to apply coupon.");
//       }
//     } catch (error) {
//       console.error("Error applying coupon:", error);
//       message.error("An error occurred while applying the coupon.");
//     }
//   };

//   const handlePlaceOrder = () => {
//     navigate("/address", {
//       state: { cartPageData },
//     });
//   };

//   return (
//     <>
//       <div className="cart__column">
//         <div className="cart__row">
//           <div className="cart__column--view">
//             <CartShowMore />
//             <div className="cart__row--options">
//               <div className="cart__row--selection">
//                 <div className="cart__view"></div>
//                 <h2 className="cart__text--price-details ui heading size-headingmd">
//                   {selectedCount}/{totalCount} ITEMS SELECTED
//                 </h2>
//               </div>
//               <div className="cart__row--actions">
//                 <h3
//                   className="cart__text--remove ui heading size-headingmd"
//                   onClick={() => showConfirm()}
//                 >
//                   REMOVE
//                 </h3>
//                 <h4
//                   className="cart__text--wishlist ui heading size-headingmd"
//                   onClick={() => addToWishlist()}
//                 >
//                   MOVE TO WISHLIST
//                 </h4>
//               </div>
//             </div>
//             <div className="cart__list--items">
//               {cartPageData?.items?.map((e) => (
//                 <CartProductDetail
//                   title={e.customTShirtPrint.product.category}
//                   description={e.customTShirtPrint.product.name}
//                   currentPrice={e.customTShirtPrint.product.discountPrice}
//                   originalPrice={e.customTShirtPrint.product.price}
//                   discount={e.customTShirtPrint.product.discount}
//                   deliveryDate="2 Dec 2024"
//                   primaryImage={e.customTShirtPrint.product.primaryImage}
//                   isSelected={e.isSelected}
//                   id={e.customTShirtPrint.product._id}
//                   size={e.customTShirtPrint.tShirtSize}
//                   quantity={e.quantity}
//                 />
//               ))}
//             </div>
//           </div>
//           <div className="cart__column--discounts">
//             <div className="cart__column--coupons">
//               <div className="cart__row--apply">
//                 <div className="cart__row--discount">
//                   <img
//                     src={discount}
//                     alt="Discount Image"
//                     className="discount-offer-row__image"
//                   />
//                   <h5 className="cart__text--price-details ui heading size-headingmd">
//                     Apply Coupons
//                   </h5>
//                 </div>
//                 <button
//                   className="flex-row-center-center cart__button--apply ui button white_a700 size-sm fill"
//                   onClick={applyCoupon}
//                 >
//                   APPLY
//                 </button>
//               </div>
//               <div className="cart__list--views">
//                 <div className="listview">
//                   {couponData?.couponCodeDetails?.map((e) => (
//                     <div
//                       className={`stackview ${
//                         selectedCoupon?._id === e._id ? "selected" : ""
//                       }`}
//                       key={e._id}
//                       onClick={() => setSelectedCoupon(e)}
//                       style={{
//                         cursor: "pointer",
//                         border:
//                           selectedCoupon?._id === e._id
//                             ? "2px solid blue"
//                             : "none",
//                       }}
//                     >
//                       <div className="rowview_one">
//                         <div className="rowview_one">
//                           <div className="view"></div>
//                           <div className="rowprice">
//                             <div className="columnprice-4">
//                               <h2 className="price ui heading size-headinglg">
//                                 {e.discountType === "percentage"
//                                   ? `FLAT ${e.discountValue}%`
//                                   : `FLAT ₹${e.discountValue}`}
//                               </h2>
//                               <p className="price-1 ui text size-textxs">
//                                 {e.description}
//                               </p>
//                               <div className="row-3">
//                                 <div className="rowcode">
//                                   <p className="code ui text size-textxs">
//                                     CODE:
//                                   </p>
//                                   <h3 className="welcometwentytw ui heading size-headingxs">
//                                     {e.code}
//                                   </h3>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="columnvelidityd">
//                               <p className="price-1 ui text size-textxs">
//                                 VALIDITY DATE
//                               </p>
//                               <div className="row-3">
//                                 <div className="rowcode">
//                                   <p className="code ui text size-textxs">
//                                     DATE:
//                                   </p>
//                                   <h4 className="welcometwentytw ui heading size-headingxs">
//                                     {formatDate(e.startDate)} -{" "}
//                                     {formatDate(e.endDate)}
//                                   </h4>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="view_one"></div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="cart__column--summary">
//               <h5 className="cart__text--price-details ui heading size-headingmd">
//                 PRICE DETAILS ({totalCount} Items Total)
//               </h5>
//               <div className="cart__column--place">
//                 <div>
//                   <div className="cart__row--total-mrp">
//                     <p className="cart__text--total-mrp ui text size-text2xl">
//                       Total MRP
//                     </p>

//                     <p className="cart__text--total-mrp ui text size-text2xl">
//                       ₹{allMrpAmount.toFixed(2)}
//                     </p>
//                   </div>

//                   <div className="cart__row--discounts">
//                     <div className="cart__row--discount-on-mrp">
//                       <p className="cart__text--total-mrp ui text size-text2xl">
//                         Discount on MRP
//                       </p>
//                       <h6 className="cart__text--know-more ui heading size-headings">
//                         Know More
//                       </h6>
//                     </div>
//                     <p className="cart__text--discount-value ui text size-text2xl">
//                       -₹{allDiscountAmount.toFixed(2)}
//                     </p>
//                   </div>

//                   {/* Coupon Discount */}
//                   <div className="cart__row--coupon-discount">
//                     <p className="cart__text--coupon-discount ui text size-text2xl">
//                       Coupon Discount
//                     </p>
//                     <p
//                       className="cart__text--apply-coupon ui text size-text2xl"
//                       onClick={showCouponModal}
//                     >
//                       Apply Coupon
//                     </p>
//                   </div>

//                   {/* coupon discount  */}
//                   <div className="cart__row--shipping">
//                     <div className="cart__column--shipping">
//                       <div className="cart__row--shipping-fee">
//                         <p className="cart__text--total-mrp ui text size-text2xl">
//                           Discount on Coupon
//                         </p>
//                       </div>
//                     </div>
//                     <div className="cart__row--free">
//                       <p className="cart__text--discount-value ui text size-text2xl">
//                         - ₹{cartPageData.discountAmountOnCoupon || 0}
//                       </p>
//                     </div>
//                   </div>

//                   {/* Shipping Fee */}
//                   <div className="cart__row--shipping">
//                     <div className="cart__column--shipping">
//                       <div className="cart__row--shipping-fee">
//                         <p className="cart__text--total-mrp ui text size-text2xl">
//                           Shipping Fee
//                         </p>
//                         <h6 className="cart__text--know-more ui heading size-headings">
//                           Know More
//                         </h6>
//                       </div>
//                       <p className="cart__text--free-shipping ui text size-text2xl">
//                         Free shipping for you
//                       </p>
//                     </div>
//                     <div className="cart__row--free">
//                       <p className="cart__text--old-price ui text size-text2xl">
//                         ₹80
//                       </p>
//                       <p className="cart__text--discount-value ui text size-text2xl">
//                         FREE
//                       </p>
//                     </div>
//                   </div>

//                   {/* Total Amount */}
//                   <div className="cart__row--total-amount">
//                     <h5 className="cart__text--price-details ui heading size-headingmd">
//                       Total Amount
//                     </h5>
//                     <h5 className="cart__text--price-details ui heading size-headingmd">
//                       ₹{cartPageData.finalAmount?.toFixed(2)}
//                     </h5>
//                   </div>
//                 </div>

//                 <button
//                   onClick={handlePlaceOrder}
//                   className="flex-row-center-center cart__button--place-order ui button deep_orange_700 size-2xl fill round"
//                 >
//                   PLACE ORDER
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Modal
//         title="Enter Coupon Code"
//         visible={isCouponModalVisible}
//         onOk={applyCouponWithCode}
//         onCancel={() => setIsCouponModalVisible(false)}
//         okText="Apply"
//         cancelText="Cancel"
//       >
//         <Input
//           placeholder="Enter your coupon code"
//           value={couponCode}
//           onChange={(e) => setCouponCode(e.target.value)}
//         />
//       </Modal>
//     </>
//   );
// };

// export default CartPage;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CartProductDetail from "component/CartProductDetail";
import CheckoutStepper from "component/CheckoutStepper/CheckoutStepper";
import "./CartPage.css";
import Service from "services/service";
import { globalStore } from "stores/globalStore";
import { Modal, Input, message } from "antd";

const CartPage = () => {
  const {
    cartPageData,
    setCartPageData,
    setCartCount,
    pinCodeData,
    setPinCodeData,
  } = globalStore();

  const [selectedCount, setSelectedCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [allMrpAmount, setAllMrpAmount] = useState(0);
  const [allDiscountAmount, setAllDiscountAmount] = useState(0);
  const [allTotalPrice, setAllTotalPrice] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [pincode, setPincode] = useState("");
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (cartPageData?.items) {
      const selectedItems = cartPageData.items.filter(
        (item) => item.isSelected
      );

      setSelectedCount(selectedItems.length);
      setTotalCount(cartPageData.items.length);

      // Calculate all items summary
      const totalAllMrp = cartPageData.items.reduce(
        (sum, item) =>
          sum + item.customTShirtPrint.product.price * item.quantity,
        0
      );

      const totalAllDiscounted = cartPageData.items.reduce(
        (sum, item) =>
          sum + item.customTShirtPrint.product.discountPrice * item.quantity,
        0
      );

      setAllMrpAmount(totalAllMrp);
      setAllDiscountAmount(totalAllMrp - totalAllDiscounted);
      const couponAmt = cartPageData.discountAmountOnCoupon || 0;
      setCouponDiscount(couponAmt);
      setAllTotalPrice(totalAllDiscounted - couponAmt);
    }
  }, [cartPageData]);

  const getAllCartData = async () => {
    try {
      const response = await Service.getAllCartData();
      const updatedData = {
        ...response.data.data,
        items: response.data.data.items.map((item) => ({
          ...item,
          isSelected: false,
        })),
      };
      setCartPageData(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCartData();
  }, []);

  const removeProduct = async () => {
    try {
      const selectedItems = cartPageData.items
        .filter((item) => item.isSelected)
        .map((item) => item.customTShirtPrint._id);

      if (selectedItems.length === 0) {
        message.warning("No items selected for removal.");
        return;
      }

      const payload = { itemIds: selectedItems };
      const response = await Service.removeItemFromCart(payload);
      
      if (response?.data.meta?.status) {
        const updatedItems = cartPageData.items.filter(
          (item) => !item.isSelected
        );
        setCartPageData({ ...cartPageData, items: updatedItems });
        setCartCount(updatedItems.length);
        message.success("Selected items removed successfully.");
      } else {
        message.error("Failed to remove items.");
      }
    } catch (error) {
      console.error("Error removing items:", error);
      message.error("An error occurred while removing items.");
    }
  };

  const showConfirm = () => {
    Modal.confirm({
      title: "Are you sure you want to remove the selected items?",
      content: "This action cannot be undone.",
      okText: "Yes, Remove",
      okType: "danger",
      cancelText: "Cancel",
      onOk: removeProduct,
      onCancel() {
        message.info("Item removal canceled.");
      },
    });
  };

  const addToWishlist = async () => {
    try {
      const selectedItems = cartPageData.items
        .filter((item) => item.isSelected)
        .map((item) => ({
          product: item.customTShirtPrint.product._id,
          tShirtSize: item.customTShirtPrint.tShirtSize,
        }));

      if (selectedItems.length === 0) {
        message.warning("No items selected to add to the wishlist.");
        return;
      }

      const payload = { items: selectedItems };
      const response = await Service.addOrUpdateWishlistService(payload);
      
      if (response?.meta?.status) {
        message.success("Selected items added to wishlist successfully.");
        removeProduct();
      } else {
        message.error("Failed to add items to wishlist.");
      }
    } catch (error) {
      message.error("An error occurred while adding items to the wishlist.");
    }
  };

  const handleSelectAll = () => {
    const allSelected = selectedCount === totalCount && totalCount > 0;
    const updatedItems = cartPageData.items.map((item) => ({
      ...item,
      isSelected: !allSelected,
    }));
    setCartPageData({ ...cartPageData, items: updatedItems });
  };

  const handlePincodeCheck = async () => {
    if (!pincode || pincode.length !== 6) {
      message.error("Please enter a valid 6-digit pincode");
      return;
    }
    setPincodeLoading(true);
    try {
      const response = await Service.pinChackService({ deliveryPinCode: pincode });
      setPinCodeData(response.data);
      message.success("Delivery available to your location!");
    } catch (error) {
      console.log(error);
      setPinCodeData([]);
      message.error("Delivery not available for this pincode");
    } finally {
      setPincodeLoading(false);
    }
  };

  const handlePlaceOrder = () => {
    navigate("/address", { state: { cartPageData } });
  };

  return (
    <>
      <CheckoutStepper currentStep={0} />
      <div className="cart__column">
        <div className="cart__row">
          <div className="cart__column--view">
            {/* <CartShowMore /> */}
            <div className="cart__row--options">
              <div className="cart__row--selection">
                <div
                  onClick={handleSelectAll}
                  className={`product-detail__view ${selectedCount === totalCount && totalCount > 0 ? 'product-detail__view--selected' : ''}`}
                >
                  {selectedCount === totalCount && totalCount > 0 && (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
                <h2 className="cart__text--price-details ui heading size-headingmd">
                  {selectedCount}/{totalCount} ITEMS SELECTED
                </h2>
              </div>
              <div className="cart__row--actions">
                <h3
                  className="cart__text--remove ui heading size-headingmd"
                  onClick={() => showConfirm()}
                >
                  REMOVE
                </h3>
                <h4
                  className="cart__text--wishlist ui heading size-headingmd"
                  onClick={() => addToWishlist()}
                >
                  MOVE TO WISHLIST
                </h4>
              </div>
            </div>
            <div className="cart__list--items">
              {cartPageData?.items?.map((e) => (
                <CartProductDetail
                  key={e.customTShirtPrint._id}
                  title={e.customTShirtPrint.product.category}
                  description={e.customTShirtPrint.product.name}
                  currentPrice={e.customTShirtPrint.product.discountPrice}
                  originalPrice={e.customTShirtPrint.product.price}
                  discount={e.customTShirtPrint.product.discount}
                  deliveryDate="2 Dec 2024"
                  primaryImage={e.customTShirtPrint.product.primaryImage}
                  isSelected={e.isSelected}
                  id={e.customTShirtPrint.product._id}
                  cartItemId={e.customTShirtPrint._id}
                  size={e.customTShirtPrint.tShirtSize}
                  quantity={e.quantity}
                />
              ))}
            </div>
          </div>
          
          {/* Price Summary Section */}
          <div className="cart__column--summary">
            <h5 className="cart__text--price-details ui heading size-headingmd">
              PRICE DETAILS ({totalCount} Items Total)
            </h5>
            <div className="cart__column--place">
              <div>
                <div className="cart__row--total-mrp">
                  <p className="cart__text--total-mrp ui text size-text2xl">
                    Total MRP
                  </p>
                  <p className="cart__text--total-mrp ui text size-text2xl">
                    ₹{allMrpAmount.toFixed(2)}
                  </p>
                </div>

                <div className="cart__row--discounts">
                  <div className="cart__row--discount-on-mrp">
                    <p className="cart__text--total-mrp ui text size-text2xl">
                      Discount on MRP
                    </p>
                    <h6 className="cart__text--know-more ui heading size-headings">
                      Know More
                    </h6>
                  </div>
                  <p className="cart__text--discount-value ui text size-text2xl">
                    -₹{allDiscountAmount.toFixed(2)}
                  </p>
                </div>

                {/* Shipping Fee */}
                <div className="cart__row--shipping">
                  <div className="cart__column--shipping">
                    <div className="cart__row--shipping-fee">
                      <p className="cart__text--total-mrp ui text size-text2xl">
                        Shipping Fee
                      </p>
                      <h6 className="cart__text--know-more ui heading size-headings">
                        Know More
                      </h6>
                    </div>
                    <p className="cart__text--free-shipping ui text size-text2xl">
                      Free shipping for you
                    </p>
                  </div>
                  <div className="cart__row--free">
                    <p className="cart__text--old-price ui text size-text2xl">
                      ₹80
                    </p>
                    <p className="cart__text--discount-value ui text size-text2xl">
                      FREE
                    </p>
                  </div>
                </div>

                {/* Total Amount */}
                <div className="cart__row--total-amount">
                  <h5 className="cart__text--price-details ui heading size-headingmd">
                    Total Amount
                  </h5>
                  <h5 className="cart__text--price-details ui heading size-headingmd">
                    ₹{allTotalPrice.toFixed(2)}
                  </h5>
                </div>
              </div>

              {/* Pincode Delivery Check */}
              <div className="cart__pincode-check">
                <p className="cart__text--total-mrp ui text size-text2xl" style={{ marginBottom: '8px' }}>
                  Check Delivery Availability
                </p>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Input
                    placeholder="Enter 6-digit pincode"
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value.replace(/\D/g, ''))}
                    maxLength={6}
                    style={{ flex: 1 }}
                  />
                  <button
                    onClick={handlePincodeCheck}
                    disabled={pincodeLoading}
                    className="flex-row-center-center cart__button--apply ui button white_a700 size-sm fill"
                  >
                    {pincodeLoading ? "Checking..." : "CHECK"}
                  </button>
                </div>
                {pinCodeData && pinCodeData.length > 0 && (
                  <div style={{ marginTop: '10px', padding: '10px', background: '#f0fdf4', borderRadius: '6px', fontSize: '13px' }}>
                    <p style={{ color: '#16a34a', fontWeight: 600 }}>✓ Delivery Available</p>
                    <p>Courier: {pinCodeData[1]?.courier_name}</p>
                    <p>Est. Delivery: {pinCodeData[0]?.etd} ({pinCodeData[0]?.etd_hours} hrs)</p>
                  </div>
                )}
              </div>

              <button
                onClick={handlePlaceOrder}
                className="flex-row-center-center cart__button--place-order ui button deep_orange_700 size-2xl fill round"
              >
                PLACE ORDER
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartPage;